export default __webpack_public_path__ + "static/blob4-25cd0ff364f62c387499b404e734b30f.svg";